/** Rotating status lines for branded splash — keep in sync with public/index.html. */

export const SPLASH_MESSAGES_RU = [
  'Читаем расписание…',
  'Подключаем Telegram…',
  'Подключаем MAX…',
  'Синхронизируем Яндекс Календарь…',
  'Синхронизируем Google Календарь…',
  'Проверяем соединение…',
  'Загружаем контакты…',
  'Читаем файлы и метаданные…',
  'Заглядываем в Outlook…',
  'Ищем в WhatsApp…',
  'Загружаем события…',
  'Выгружаем события…',
  'Синхронизируем часовые пояса…',
  'Отправляем и получаем письма…',
  'Наводим порядок…',
  'Почти готово…',
];

export const SPLASH_MESSAGES_EN = [
  'Reading your schedule…',
  'Connecting Telegram…',
  'Connecting MAX…',
  'Syncing Yandex Calendar…',
  'Syncing Google Calendar…',
  'Checking connection…',
  'Loading contacts…',
  'Reading files and metadata…',
  'Looking up Outlook…',
  'Searching WhatsApp…',
  'Downloading events…',
  'Uploading events…',
  'Synchronizing world clocks…',
  'Sending and receiving emails…',
  'Tidying up…',
  'Almost ready…',
];

export const SPLASH_MESSAGE_INTERVAL_MS = 1650;

export const SPLASH_LOGO_SRC = '/icons/icon-192.png';

/** Prefer RU unless language is English (matches index.html boot splash). */
export function splashMessagesForLang(lang) {
  const l = String(lang || 'ru').toLowerCase();
  return l.indexOf('en') === 0 ? SPLASH_MESSAGES_EN : SPLASH_MESSAGES_RU;
}

export function resolveSplashLang() {
  try {
    const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
    if (stored) return stored;
  } catch {
    /* ignore */
  }
  if (typeof navigator !== 'undefined' && navigator.language) return navigator.language;
  return 'ru';
}
